// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.close-button {
  position: absolute;
  right: 1%;
  top: 1%;
  z-index: 999;
  cursor: pointer;
}
.close-button img {
  width: 100%;
  padding: 15%;
}
.container-box {
  background: var(--color-white);
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  position: absolute;
  right: 2%;
  margin-top: 2%;
  z-index: 999;
  width: 30cqw;
  font-family: var(--font-family-first);
  height: 80vh;
  overflow-y: auto;
}
.container-box::-webkit-scrollbar-track {
  background: none;
}

.container-box::-webkit-scrollbar-thumb {
  background-color: var(--color-second);
  border-radius: 10px;
}

.city-images {
  display: flex;
  width: 100%;
  padding: 0 10%;
  overflow: hidden;
  height: 20vh;
}
.city-images img {
  width: 100%;
  border-radius: 10px;
  object-fit: cover;
}
.pool-info {
  padding: 1% 10%;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}
.pool-info .info-item {
  font-weight: bold;
  font-size: 0.9cqw;
}
.pool-info .info-item .detail a {
  display: block;
  font-size: 0.8cqw;
  text-decoration: underline !important;
  color: var(--color-third);
}
.pool-info .info-item .progress-container {
  width: 100%;
  height: 2vh;
  background-color: var(--color-first-opacity);
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 0 3px 1px var(--color-first);
  position: relative;
  margin: 3% 0;
}
.pool-info .info-item .progress-container .text {
  position: absolute;
  color: var(--color-white);
  top: 0;
  right: 2%;
  font-size: 0.75cqw;
}
.pool-info .info-item .progress-bar {
  height: 100%;
  background: linear-gradient(
    to right,
    var(--color-first) 0%,
    var(--color-third) 50%,
    var(--color-second) 100%
  );
  transition: width 0.5s ease;
}
.token-amount {
  display: flex;
  justify-content: space-between;
  margin-bottom: 3%;
}
.token-amount .amountText {
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 400;
  padding: 5%;
  transform: rotate(270deg);
}
.token-amount .input-area {
  width: 100%;
  display: inline-flex;
}
.token-amount .input-area input {
  width: 100%;
  display: flex;
  align-items: center;
  border: 0;
  border-radius: 10px;
  background: var(--color-first-opacity);
  color: var(--color-white);
  font-size: 1cqw;
  font-weight: 600;
  padding-left: 10%;
}
.token-amount .input-area input::placeholder {
  color: #f8efe388;
  font-size: 0.8cqw;
}

.token-amount button {
  flex: 1 1;
  margin: 0 5px;
  background-color: var(--color-third);
  border: none;
  border-radius: 5px;
  padding: 10px 0;
  cursor: pointer;
  transition: background-color 0.3s;
}

.token-amount button:hover {
  background-color: var(--color-first);
}
.stake-button {
  width: 50%;
  background-size: contain;
  background-color: var(--color-third);
  border: none;
  border-radius: 10px;
  padding: 3% 0;
  cursor: pointer;
  transition: background-color 0.5s;
  color: var(--color-white);
  font-weight: 600;
  font-size: 1cqw;
}
.stake-button:hover {
  background-color: var(--color-first);
}

.stake-button:before {
  background-color: var(--color-first);
  content: "";
  height: 100%;
  left: -100%;
  position: absolute;
  top: 0;
  width: 0;
  z-index: -1;
  transform: skew(50deg);
  transition: width 0.6s;
  transform-origin: top left;
}
.stakeheader span:last-child:after {
  opacity: 0;
}
.stakeheader img {
  height: 1.25cqw;
  margin-right: 2%;
}
.stakeheader .close-button {
  position: absolute;
  z-index: 1000;
}
.stakeheader {
  position: relative;
  background-color: var(--color-white);
  top: 0;
  padding: 2% 10%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.stakeheader h1 {
  display: flex;
  align-items: center;
}
.stakeheader .info {
  position: relative;
  font-size: 0.8cqw;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 32%;
  width: 100%;
  text-align: center;
  font-weight: 500;
}
.stakeheader .info .text {
  font-size: 0.85cqw;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.stakeheader .divider {
  padding: 5% 1px;
  background-color: var(--color-black);
  margin: 0 2%;
}
.stakeheader * {
  margin: 0;
}
.footer {
  background: transparent;
  margin: 3% 0;
  font-size: 0.9cqw;
  color: var(--color-black);
}
.footer a {
  color: var(--color-third);
}
.container-box-bottom {
  width: 100%;
  padding: 0 10%;
  justify-self: center;
}
.btns-area {
  display: flex;
  justify-content: center;
  width: 100%;
}
.minamount {
  font-size: 0.7cqw;
  padding: 0 10%;
}
.hideglobe {
  left: 10px !important;
}
.connect-button-field {
  margin: 20px 0;
}
.viewAnim {
  display: inline-block;
  animation: viewTicketAnim infinite 1500ms;
}
@keyframes viewTicketAnim {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}
.gap5 {
  gap: 5%;
}

.unlock-msg {
  color: var(--color-white);
  background-color: var(--color-first);
  border-radius: 15px;
  padding: 1% 3%;
  font-size: 0.6cqw;
  font-weight: 500;
  margin-bottom: 3%;
  width: 50%;
}
`, "",{"version":3,"sources":["webpack://./src/components/stake/Stake.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,YAAY;EACZ,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;EACxC,kBAAkB;EAClB,SAAS;EACT,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,qCAAqC;EACrC,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,qCAAqC;EACrC,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,WAAW;EACX,4CAA4C;EAC5C,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,MAAM;EACN,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ;;;;;GAKC;EACD,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,sCAAsC;EACtC,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,UAAU;EACV,wBAAwB;EACxB,oCAAoC;EACpC,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,iCAAiC;EACjC,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,WAAW;EACX,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,WAAW;EAGX,sBAAsB;EAGtB,sBAAsB;EAGtB,0BAA0B;AAC5B;AACA;EACE,UAAU;AACZ;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,MAAM;EACN,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,oCAAoC;EACpC,YAAY;AACd;AACA;EACE,SAAS;AACX;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,yCAAyC;AAC3C;AACA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE,OAAO;AACT;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;AACZ","sourcesContent":[".close-button {\n  position: absolute;\n  right: 1%;\n  top: 1%;\n  z-index: 999;\n  cursor: pointer;\n}\n.close-button img {\n  width: 100%;\n  padding: 15%;\n}\n.container-box {\n  background: var(--color-white);\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  position: absolute;\n  right: 2%;\n  margin-top: 2%;\n  z-index: 999;\n  width: 30cqw;\n  font-family: var(--font-family-first);\n  height: 80vh;\n  overflow-y: auto;\n}\n.container-box::-webkit-scrollbar-track {\n  background: none;\n}\n\n.container-box::-webkit-scrollbar-thumb {\n  background-color: var(--color-second);\n  border-radius: 10px;\n}\n\n.city-images {\n  display: flex;\n  width: 100%;\n  padding: 0 10%;\n  overflow: hidden;\n  height: 20vh;\n}\n.city-images img {\n  width: 100%;\n  border-radius: 10px;\n  object-fit: cover;\n}\n.pool-info {\n  padding: 1% 10%;\n  background: transparent;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n}\n.pool-info .info-item {\n  font-weight: bold;\n  font-size: 0.9cqw;\n}\n.pool-info .info-item .detail a {\n  display: block;\n  font-size: 0.8cqw;\n  text-decoration: underline !important;\n  color: var(--color-third);\n}\n.pool-info .info-item .progress-container {\n  width: 100%;\n  height: 2vh;\n  background-color: var(--color-first-opacity);\n  border-radius: 15px;\n  overflow: hidden;\n  box-shadow: 0 0 3px 1px var(--color-first);\n  position: relative;\n  margin: 3% 0;\n}\n.pool-info .info-item .progress-container .text {\n  position: absolute;\n  color: var(--color-white);\n  top: 0;\n  right: 2%;\n  font-size: 0.75cqw;\n}\n.pool-info .info-item .progress-bar {\n  height: 100%;\n  background: linear-gradient(\n    to right,\n    var(--color-first) 0%,\n    var(--color-third) 50%,\n    var(--color-second) 100%\n  );\n  transition: width 0.5s ease;\n}\n.token-amount {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 3%;\n}\n.token-amount .amountText {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: 400;\n  padding: 5%;\n  transform: rotate(270deg);\n}\n.token-amount .input-area {\n  width: 100%;\n  display: inline-flex;\n}\n.token-amount .input-area input {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  border: 0;\n  border-radius: 10px;\n  background: var(--color-first-opacity);\n  color: var(--color-white);\n  font-size: 1cqw;\n  font-weight: 600;\n  padding-left: 10%;\n}\n.token-amount .input-area input::placeholder {\n  color: #f8efe388;\n  font-size: 0.8cqw;\n}\n\n.token-amount button {\n  flex: 1 1;\n  margin: 0 5px;\n  background-color: var(--color-third);\n  border: none;\n  border-radius: 5px;\n  padding: 10px 0;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.token-amount button:hover {\n  background-color: var(--color-first);\n}\n.stake-button {\n  width: 50%;\n  background-size: contain;\n  background-color: var(--color-third);\n  border: none;\n  border-radius: 10px;\n  padding: 3% 0;\n  cursor: pointer;\n  transition: background-color 0.5s;\n  color: var(--color-white);\n  font-weight: 600;\n  font-size: 1cqw;\n}\n.stake-button:hover {\n  background-color: var(--color-first);\n}\n\n.stake-button:before {\n  background-color: var(--color-first);\n  content: \"\";\n  height: 100%;\n  left: -100%;\n  position: absolute;\n  top: 0;\n  width: 0;\n  z-index: -1;\n  -webkit-transform: skew(50deg);\n  -ms-transform: skew(50deg);\n  transform: skew(50deg);\n  -webkit-transition: width 0.6s;\n  -o-transition: width 0.6s;\n  transition: width 0.6s;\n  -webkit-transform-origin: top left;\n  -ms-transform-origin: top left;\n  transform-origin: top left;\n}\n.stakeheader span:last-child:after {\n  opacity: 0;\n}\n.stakeheader img {\n  height: 1.25cqw;\n  margin-right: 2%;\n}\n.stakeheader .close-button {\n  position: absolute;\n  z-index: 1000;\n}\n.stakeheader {\n  position: relative;\n  background-color: var(--color-white);\n  top: 0;\n  padding: 2% 10%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.stakeheader h1 {\n  display: flex;\n  align-items: center;\n}\n.stakeheader .info {\n  position: relative;\n  font-size: 0.8cqw;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 32%;\n  width: 100%;\n  text-align: center;\n  font-weight: 500;\n}\n.stakeheader .info .text {\n  font-size: 0.85cqw;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.stakeheader .divider {\n  padding: 5% 1px;\n  background-color: var(--color-black);\n  margin: 0 2%;\n}\n.stakeheader * {\n  margin: 0;\n}\n.footer {\n  background: transparent;\n  margin: 3% 0;\n  font-size: 0.9cqw;\n  color: var(--color-black);\n}\n.footer a {\n  color: var(--color-third);\n}\n.container-box-bottom {\n  width: 100%;\n  padding: 0 10%;\n  justify-self: center;\n}\n.btns-area {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n}\n.minamount {\n  font-size: 0.7cqw;\n  padding: 0 10%;\n}\n.hideglobe {\n  left: 10px !important;\n}\n.connect-button-field {\n  margin: 20px 0;\n}\n.viewAnim {\n  display: inline-block;\n  animation: viewTicketAnim infinite 1500ms;\n}\n@keyframes viewTicketAnim {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.05);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n.gap5 {\n  gap: 5%;\n}\n\n.unlock-msg {\n  color: var(--color-white);\n  background-color: var(--color-first);\n  border-radius: 15px;\n  padding: 1% 3%;\n  font-size: 0.6cqw;\n  font-weight: 500;\n  margin-bottom: 3%;\n  width: 50%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
